import router from '@/router'
//import { sha256 } from 'js-sha256';
const config = require('../../config');
import api from './../../services/index.js'
import { v4 as uuidv4 } from 'uuid';
import NodeRSA from 'node-rsa'
export const actions = {
    async userSignIn({ commit }, payload) {
        try {
            commit('setLoading', true)
            api.post('/login', {
                    username: this.CryptoJS.AES.encrypt(
                        payload.username,
                        config.Crypto_Secret
                    ).toString(),
                    password: this.CryptoJS.AES.encrypt(
                        payload.password,
                        config.Crypto_Secret
                    ).toString(),
                })
                .then(async(v) => {
                    if (v.status.code == 200) {
                        if (v.data.token) {
                            this.setAccessToken(v.data.token);
                            this.$router.push("/home");
                        } else {
                            this.$swal.fire({
                                icon: "error",
                                title: v.status.message,
                                timerProgressBar: true,
                                allowOutsideClick: false,
                            });
                        }
                    } else {
                        this.$swal.fire({
                            icon: "error",
                            title: v.status.message,
                            timerProgressBar: true,
                            allowOutsideClick: false,
                        });
                    }
                })
                .catch(async(e) => {
                    this.$swal.fire({
                        icon: "error",
                        title: e.status.message,
                        timerProgressBar: true,
                        allowOutsideClick: false,
                    });
                });
        } catch (error) {
            commit('setError', error.message)
        } finally {
            commit('setLoading', false)
        }
    },
    async checkAuth({ commit }) {
        try {
            const AccessToken = localStorage.getItem("AccessToken");
            if (AccessToken != null) {
                const v = await api.get('/auth-service/v1/login/refresh', {
                    headers: {
                        "X-AUTH-KEY": AccessToken,
                        "X-API-KEY": config.SecertKey,
                        "Content-Type": "application/json",
                    }
                })
                if (v.data.isLogin != true) {
                    commit('setError', null);
                    localStorage.setItem("AccessToken", null)
                    await router.push("/login").catch(() => {})
                }
            } else {
                commit('setError', null);
                localStorage.setItem("AccessToken", null)
                await router.push("/login").catch(() => {})
            }
            return true;
        } catch (err) {
            commit('setError', null);
            localStorage.setItem("AccessToken", null)
            await router.push("/login").catch(() => {})
            return err.response.data
        }
    },
    async Initialization({ commit }) {
        try {
            const keyPair = new NodeRSA().generateKeyPair();
            commit('setInitialize', { priKey: Buffer.from(Buffer.from(keyPair.exportKey('pkcs1-pem')).toString('hex')).toString('base64') }); // store privateKey
            api.post('/initialize', {
                deviceId: uuidv4().toLocaleUpperCase().replace(/-/g, '๐'),
                tileVersion: config,
                pubKey: Buffer.from(Buffer.from(keyPair.exportKey('pkcs8-public-pem')).toString('hex')).toString('base64')
            }).then((v) => {
                console.log(v)
            }).catch((e) => {
                console.log(e)
            })
        } catch (e) {
            console.log(e)
        }
    },
    setAccessToken({ commit }, payload) {
        localStorage.setItem("AccessToken", payload)
        commit('setAccessToken', payload)
    },
    setError({ commit }, payload) {
        commit('setError', payload)
    },
    setLoading({ commit }, payload) {
        commit('setLoading', payload)
    }
}